import { createSlice } from '@reduxjs/toolkit';
import { getVehicleOptions } from './thunks/commonInfoThunks';

const vehicleOptionsSlice = createSlice({
    name: 'vehicleOptions',
    initialState: {
        data: null,
        isLoading: false,
        cacheKey: null,
    },
    reducers: {
        clearVehicleOptions: (state) => {
            state.data = null;
            state.isLoading = false;
            state.cacheKey = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getVehicleOptions.pending, (state, action) => {
                state.isLoading = true;
                state.cacheKey = action.meta.arg?.cacheKey || null;
            })
            .addCase(getVehicleOptions.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload || null;
            })
            .addCase(getVehicleOptions.rejected, (state) => {
                state.isLoading = false;
                state.data = null;
            });
    },
});

export const { clearVehicleOptions } = vehicleOptionsSlice.actions;
export const vehicleOptions = vehicleOptionsSlice.reducer;

export const selectVehicleOptions = (state) => state.vehicleOptions?.data;
export const selectVehicleOptionsLoading = (state) =>
    state.vehicleOptions?.isLoading || false;
